import styled, { css } from 'styled-components';

import { Box } from '@/components/Box';
import { Flex } from '@/components/Flex';
import { LegacyButton } from '@/components/LegacyButton';
import { Typography } from '@/components/Typography';

export const Section = styled(Flex)<{
  variant: 'sign-in' | 'guest' | 'sign-up';
}>`
  justify-content: center;
  align-items: center;
  flex-direction: column;

  ${({ theme, variant }) =>
    css`
      padding: ${theme.spacing(4, 2)};
      background-color: ${variant === 'guest' || variant === 'sign-up'
        ? theme.colors.primaryBlue
        : theme.colors.primary};
      width: 100%;

      a {
        font-size: ${theme.fontSizes.p2};
        color: ${theme.colors.primaryBlue};
        margin-top: ${theme.spacing(3)};
      }

      ${theme.media.sm.up} {
        height: 450px;

        a {
          margin-top: ${theme.spacing(2)};
        }
      }
    `}
`;

export const Container = styled(Flex)`
  flex-direction: column;
  align-items: center;
  width: 100%;
`;

export const FieldsWrapper = styled(Flex)<{ $layout?: 'account' | 'delivery' }>`
  width: 100%;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(2)};
  margin: 0 auto;

  ${({ $layout, theme }) => css`
    gap: ${theme.spacing(2)};

    ${$layout !== 'delivery' &&
    css`
      ${theme.media.sm.up} {
        max-width: 388px;
      }
    `}
  `}
`;

export const DeliveryFieldCell = styled(Box)`
  width: 100%;

  [data-test-id='InputWrapper'] {
    min-height: 48px;
  }
`;

export const DeliveryActionsRow = styled(Flex)`
  ${({ theme }) => css`
    width: 100%;
    flex-direction: column;
    align-items: stretch;
    gap: ${theme.spacing(2)};

    ${theme.media.sm.up} {
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
    }
  `}
`;

export const ButtonContainer = styled(Box)`
  ${({ theme }) => css`
    ${theme.media.sm.down} {
      width: 100%;
    }
  `}
`;

export const SubmitButton = styled(LegacyButton)<{
  $layout?: 'account' | 'delivery';
}>`
  margin: 0 auto;

  ${({ $layout, theme }) => css`
    ${theme.media.sm.down} {
      width: 100%;
    }

    ${$layout === 'delivery' &&
    css`
      margin: 0;
      width: 100%;

      ${theme.media.sm.up} {
        width: auto;
        min-width: 150px;
      }
    `}
  `}
`;

export const Description = styled(Typography)`
  max-width: 355px;

  ${({ theme }) => css`
    font-size: ${theme.fontSizes.p2};
    color: ${theme.colors.lightGrey};
    margin-bottom: ${theme.spacing(2)};
  `}
`;

export const SignUpBenefitsWrapper = styled(Box)`
  ${({ theme }) => css`
    order: 1;
    padding: ${theme.spacing(2)} 0 0;
    color: ${theme.colors.white};
    margin-bottom: ${theme.spacing(3)};
    text-align: left;
    line-height: 1.4;
    font-size: ${theme.fontSizes.p2};

    p {
      margin-bottom: ${theme.spacing(1)};
    }

    ul {
      list-style-type: disc;
      padding-left: ${theme.spacing(2)};
      margin: 0;
    }

    li {
      margin-top: ${theme.spacing(0.5)};
    }

    ${theme.media.md.up} {
      padding: 0 ${theme.spacing(6)};
    }

    ${theme.media.sm.up} {
      order: 0;
    }
  `}
`;
